<template>
  <div id="app">
    <Navbar />

    <div class="container">
      <router-view />
    </div>

    <Footbar />
  </div>
</template>

<script>
  import Navbar from '@/components/widgets/Navbar'
  import Footbar from '@/components/widgets/Footbar'

  export default {
    name: 'app',
    components: { Navbar, Footbar },
  }
</script>

<style>
  body {
    font-family: 'Open Sans', sans-serif;
    font-size: 0.9rem;
  }
  h6 {
    text-transform: uppercase;
    font-size: 0.8rem;
    color: gray;

    padding-top: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue